import { render, staticRenderFns } from "./ExamPassCount.vue?vue&type=template&id=405bcf36&scoped=true"
import script from "./ExamPassCount.vue?vue&type=script&lang=js"
export * from "./ExamPassCount.vue?vue&type=script&lang=js"
import style0 from "./ExamPassCount.vue?vue&type=style&index=0&id=405bcf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405bcf36",
  null
  
)

export default component.exports